import Vue from "vue";
import CapConstant from "@/common/capconstant.js";
import {UserType} from "@/common/constant.js";
import Axios from "axios";

const globalstore = Vue.observable({
   appsettings: null,
   appready: false,

   user: {
      isLoggedIn: false,
      tokenexpired: false,
      userid: "",
      useremail: "",
      username: "",
      rolename: "",
      usertype: null,
      userroles: [],
      usercap: [],
      usertoken: "",
      userMenu: [],
      userlinkid: "",
      usersso: "",
      msgindex: null,
      lastsettingapp: null,
   },
   schoolcolor: "red darken-2 white--text",
   error_titleclass: "red darken-2 white--text",
   success_titleclass: "green darken-1 white--text",
   primary_titleclass: "primary white--text",
   secondary_titleclass: "primary lighten-2 white--text",
   table_headerclass: "teal lighten-4 font-weight-bold subtitle-1",
   table_smallheaderclass: "teal lighten-4 font-weight-bold headertext",
   primary_toastclass: "primary white--text",
   tab_slidercolor: "red darken-1",
   toolbar_headerclass: "primary white--text",
   settings_titleclass: "grey lighten-3",
   toast_successclass: "teal white--text",
   toast_errorclass: "red white--text",
   toast_warningclass: "orange white--text",

   status_select: [
      {id: 0, text: "Disabled"},
      {id: 1, text: "Enabled"},
   ],
   gender_select: [
      {id: 0, text: "Female"},
      {id: 1, text: "Male"},
      {id: 2, text: "Co-ed"},
   ],
   usertype_select: [
      {id: 0, text: "Staff"},
      {id: 1, text: "Vendor"},
      {id: 2, text: "Parent"},
      {id: 3, text: "Pupil"},
      {id: 4, text: "Transporter"},
   ],
   default_gender_select: 2,

   // variables to help in creating groups from
   // proposals and track proposal list
   proposal: {
      schedule: null,
      publishdate: null,
      closingdate: null,
      yeargroup: null,
      page: null,
      itemsperpage: 10,
      selectedproposalstatus: null,
      proposaldata: [],
   },

   // track cca group list
   ccagroup: {
      itemsperpage: null,
      page: null,
      ccagroupdata: [],
   },

   defaultmessage: {
      itemsperpage: null,
      page: null,
      messagedata: [],
   },

   ccastatistic: {
      itemsperpage: null,
      yeargroup: null,
   },

   usermanager: {
      lastid: null,
      firstid: null,
      rowcount: null,
      page: null,
      sortby: "",
      sortdesc: false,
      searchterm: "",
   },

   termyearlist: {},

   currencyoptions: {
      length: 10,
      precision: 0,
   },

   currencydecimaloptions: {
      length: 10,
      precision: 2,
   },

   percentformatter: new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
   }),

   currencyformatter: new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 0,
      signDisplay: "never",
   }),

   currencydecimalformatter: new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
      signDisplay: "never",
   }),

   // roundCurrency(amt, decimalPlaces = 2) {
   //    /**
   //     * Round half away from zero ('commercial' rounding)
   //     * Uses correction to offset floating-point inaccuracies.
   //     * Works symmetrically for positive and negative numbers.
   //     */
   //    var p = Math.pow(10, decimalPlaces);
   //    var n = amt * p * (1 + Number.EPSILON);
   //    return Math.round(n) / p;
   // },

   roundCurrency(amt, decimalPlaces = 2, roundTen = false) {
      /**
       * Round half away from zero ('commercial' rounding)
       * Uses correction to offset floating-point inaccuracies.
       * Added param to round to nearest 5
       */
      var p = Math.pow(10, decimalPlaces);
      var n = amt * p * (1 + Number.EPSILON);
      if (roundTen) {
         var m = Math.round(n) / p;
         var r = Math.round((m % 1) * p) % 10;

         if (r === 0) {
            return Math.round(n) / p;
         } else {
            if (r >= 5) {
               n += 10 - r;
               return Math.round(n) / p;
            } else {
               n -= r;
               return Math.round(n) / p;
            }
         }
      } else return Math.round(n) / p;
   },

   formatCurrency(amt, decimal = true) {
      if (amt >= 0) {
         if (decimal) return globalstore.currencydecimalformatter.format(amt);
         else return globalstore.currencyformatter.format(amt);
      } else if (decimal)
         return "(" + globalstore.currencydecimalformatter.format(Math.abs(amt)) + ")";
      else return "(" + globalstore.formatter.format(Math.abs(amt)) + ")";
   },

   formatPercentage(pct) {
      return globalstore.percentformatter.format(pct);
   },

   //=======================================================================
   // See appsettings above
   currentyear: "",
   currentterm: "",
   attendance_grace_minute: 10,
   minute_interval: 5,
   //=======================================================================

   resetUser() {
      globalstore.user.isLoggedIn = false;
      globalstore.user.tokenexpired = false;
      globalstore.user.userid = "";
      globalstore.user.useremail = "";
      globalstore.user.username = "";
      globalstore.user.rolename = "";
      globalstore.user.usertype = null;
      globalstore.user.userroles = [];
      globalstore.user.usercap = [];
      globalstore.user.usertoken = "";
      globalstore.user.usermenu = [];
      globalstore.user.userlinkid = "";
      globalstore.user.msgindex = null;
   },

   currentDateISOString() {
      return new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString();
   },

   currentDate() {
      return new Date(Date.now() - new Date().getTimezoneOffset() * 60000);
   },

   dateToISOString(date) {
      const d = new Date(date);

      const retdate =
         d.getFullYear().toString() +
         "-" +
         (d.getMonth() + 1).toString().padStart(2, "0") +
         "-" +
         d
            .getDate()
            .toString()
            .padStart(2, "0") +
         "T" +
         d
            .getHours()
            .toString()
            .padStart(2, "0") +
         ":" +
         d
            .getMinutes()
            .toString()
            .padStart(2, "0") +
         ":" +
         d
            .getSeconds()
            .toString()
            .padStart(2, "0") +
         ":" +
         d
            .getMilliseconds()
            .toString()
            .padStart(3, "0") +
         "Z";
      return retdate;
   },

   async LogOutAndResetUser() {
      await Axios({
         url: "/common/userLogout.php",
         data: {id: globalstore.user.userid},
         headers: {"Content-Type": "application/x-www-form-urlencoded"},
         method: "POST",
      }).then((response) => {
         globalstore.resetUser();
         localStorage.removeItem("usertoken");
      });
   },

   UserHasCap(capid) {
      const result = globalstore.user.usercap.find(({id}) => id === capid);
      return result;
   },

   BuildMenu() {
      globalstore.user.userMenu = [];

      globalstore.user.userMenu.push({
         icon: "mdi-home-outline",
         color: "red darken-2",
         text: "Home",
         route: "/Home",
      });
      globalstore.user.userMenu.push({
         icon: "mdi-message-text-outline",
         color: "green",
         text: "Inbox",
         route: "/Messages",
      });
      if (globalstore.user.usertype == UserType.PARENT) {
         globalstore.user.userMenu.push({
            icon: "mdi-check-decagram",
            color: "blue",
            text: "Student Profile",
            route: "/StudentProfile",
         });
      }
      if (globalstore.UserHasCap(CapConstant.SEND_MESSAGE)) {
         globalstore.user.userMenu.push({
            icon: "mdi-message-text-outline",
            color: "blue",
            text: "Messaging",
            route: "/Messaging",
         });
      }
      if (globalstore.UserHasCap(CapConstant.MANAGE_CCA_GROUP)) {
         globalstore.user.userMenu.push({
            icon: "mdi-folder-multiple",
            color: "yellow darken-4",
            text: "Group Management",
            route: "/ManageGroup",
         });
      }

      if (globalstore.UserHasCap(CapConstant.VIEW_CCA_LOG)) {
         globalstore.user.userMenu.push({
            icon: "mdi-text-box-outline",
            color: "blue lighten-1",
            text: "CCA Log",
            route: "/CCALog",
         });
      }

      if (globalstore.UserHasCap(CapConstant.CCA_PROPOSAL_FORM)) {
         globalstore.user.userMenu.push({
            icon: "mdi-format-list-checkbox",
            color: "grey",
            text: "CCA Proposal Form",
            route: "/CCAProposal",
         });
      }

      if (globalstore.UserHasCap(CapConstant.MANAGE_PROPOSAL)) {
         globalstore.user.userMenu.push({
            icon: "mdi-playlist-check",
            color: "blue",
            text: "Manage CCA Proposal",
            route: "/ManageProposal",
         });
      }

      if (globalstore.UserHasCap(CapConstant.VIEW_CCA_STATISTIC)) {
         globalstore.user.userMenu.push({
            icon: "mdi-chart-box",
            color: "red",
            text: "CCA Statistics",
            route: "/StatisticView",
         });
      }

      if (globalstore.UserHasCap(CapConstant.PARTICIPANT_LIST)) {
         globalstore.user.userMenu.push({
            icon: "list_alt",
            color: "grey",
            text: "Participant List",
            route: "/ParticipantListView",
         });
      }

      if (
         globalstore.user.usertype == UserType.STAFF &&
         globalstore.UserHasCap(CapConstant.STUDENT_PROFILE)
      ) {
         globalstore.user.userMenu.push({
            icon: "mdi-account-school",
            color: "blue",
            text: "Student Activity Info",
            route: "/StudentActivityInfo",
         });
      }

      if (globalstore.UserHasCap(CapConstant.MANAGE_LOCATION)) {
         globalstore.user.userMenu.push({
            icon: "mdi-office-building-marker",
            color: "green",
            text: "Location Management",
            route: "/ManageLocation",
         });
      }

      if (globalstore.UserHasCap(CapConstant.MANAGE_USER)) {
         globalstore.user.userMenu.push({
            icon: "mdi-account-group",
            color: "red lighten-2",
            text: "User Management",
            route: "/ManageUser",
         });
      }

      if (globalstore.UserHasCap(CapConstant.MANAGE_USER)) {
         globalstore.user.userMenu.push({
            icon: "mdi-account-settings-outline",
            color: "purple lighten-2",
            text: "Role Management",
            route: "/ManageRole",
         });
      }

      if (globalstore.UserHasCap(CapConstant.EDIT_APPSETTINGS)) {
         globalstore.user.userMenu.push({
            icon: "mdi-hammer-wrench",
            color: "red",
            text: "Settings",
            route: "/AppSetting",
         });
      }
   },
});

export default globalstore;
